import { render, staticRenderFns } from "./page.vue?vue&type=template&id=6fa2c28c&"
import script from "./page.vue?vue&type=script&lang=js&"
export * from "./page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "page.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/base/page/page.vue
// module id = 151
// module chunks = 0